import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  usersCount: {
    defaultMessage: '{count, plural, one {# user} other {# users}}',
    description: 'Number of users for a subscription plan',
    id: 'Y/VDSk',
  },
  selectUsersLabel: {
    defaultMessage: 'Select users',
    description: 'Label for users dropdown/input',
    id: 'erEKIJ',
  },
  userCountAdditionalCost: {
    defaultMessage: '+ {cost}',
    description: 'Additional cost for the selected user count',
    id: 'mebxmT',
  },
  includedAbbreviation: {
    defaultMessage: 'Incl.',
    description: 'Abbreviation for included',
    id: 'm4kUIL',
  },
});
